<div class="row">
    <div class="col-md-12">
        <yt-instrukcija-placanja-inline-update #baseInlineUpdate ></yt-instrukcija-placanja-inline-update>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">        
        <yt-fw-default-detail-list-inline 
            #baseDetailList            
            [ParentPropertyName]="_parentPropertyName"
            [ParentPropertyValue]="_parentPropertyValue" 
            [Disabled]="isDetailListDisabled(_parentPropertyValue)" 
            (Items)="setItems($event)">
        </yt-fw-default-detail-list-inline>
    </div>
</div>
<!-- [Model]="modelData.MainList.DetailList[0]"  -->
             <!-- [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0 || this.baseInlineUpdateComponent.baseUpdateComponent.saveDisabled"  -->
<!-- 
              [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0 
            || (this.baseInlineUpdateComponent.baseUpdateComponent.Parameters 
            && this.baseInlineUpdateComponent.baseUpdateComponent.Parameters.get(0)
            && this.baseInlineUpdateComponent.baseUpdateComponent.Parameters.get(0).get(0).Value !== true
            )"  -->